interface ScreenWithClient {
  client?: {
    logo_uri?: string;
    name?: string;
  };
}

/**
 * Reads `client.logo_uri` from the ACUL screen context and overrides the
 * `--ul-theme-widget-logo-url` CSS variable so each Auth0 application
 * (Guestmaker, Integrations, Admin) shows its own logo.
 *
 * Call after `applyAuth0Theme()` in each screen's index.tsx.
 */
export function useClientLogo(screenInstance: ScreenWithClient): void {
  const logoUri = screenInstance.client?.logo_uri;
  if (logoUri) {
    document.documentElement.style.setProperty(
      "--ul-theme-widget-logo-url",
      `"${logoUri}"`
    );
  }
}
